import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import { renderApplicantsCell } from './RentalPortalApplicantsTableRow.utils'

import * as styles from './RentalPortalApplicantsTableRow.module.css'

function RentalPortalApplicantsTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  activeItem,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  getIsItemSelectable,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isSelectedAll,
  item,
  resizingColumn,
  selectNotAllowedTooltip,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.RentalPortalApplicantsTableRow,
    isActive: focusedRow === item.id || activeItem === item.id,
    isSelected,
  })

  const isSelectable = isSelectedAll || getIsItemSelectable(item)

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox || !isSelectable}
          selected={isSelected}
          tooltip={isSelectable ? null : selectNotAllowedTooltip}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderApplicantsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            showCellBorder,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalApplicantsTableRow
